import { cn } from '@/utils/cn'
import type { Progress } from '@/utils/getScoreRangeValue'
import { getScoreGradientBgClass } from '@/utils/scoreColors'
import type { ComponentProps } from 'react'

export type { Progress }

interface Props extends ComponentProps<'div'> {
  progress?: Progress
  className?: string
}

export function ThreeStepProgress({ progress, className }: Props) {
  const dotClass =
    progress === undefined
      ? 'bg-[linear-gradient(180deg,rgba(var(--input-disabled),0.33)_0%,rgba(var(--disabled),0.33)_100%)]'
      : getScoreGradientBgClass(progress)

  return (
    <div className={cn('flex items-center gap-1', className)}>
      {[0, 1, 2].map((dotIndex) => (
        <div
          key={dotIndex}
          className={cn(
            'size-2 rounded-full',
            dotClass,
            progress === undefined || (dotIndex >= progress && 'opacity-[0.33]')
          )}
        />
      ))}
    </div>
  )
}
